export default __webpack_public_path__ + "static/media/f31.3ca02ef4.png";